






































































import type { PropType } from '@nuxtjs/composition-api';
import {
  computed,
  defineComponent,
  ref,
  useContext
} from '@nuxtjs/composition-api';

import { useLinesCounter } from '~/diptyqueTheme/composable';
import { useTruncatedText } from '~/diptyqueTheme/composable/useTruncatedText';
import type { AlternativeButtonConfig } from '~/diptyqueTheme/types/components';

const TRUNCATE_MODES = [
  'none',
  'by characters',
  'by lines',
  'by teaser',
  'by characters then lines',
  'by double text'
] as const;

type TruncateMode = typeof TRUNCATE_MODES[number];

export default defineComponent({
  name: 'VaimoText',
  components: {
    VaimoTruncatedToggle: () =>
      import('~/diptyqueTheme/components/atoms/VaimoTruncatedToggle.vue')
  },
  props: {
    text: {
      type: String,
      required: true
    },
    // eslint-disable-next-line vue/require-default-prop
    textLong: {
      type: String,
      required: false
    },
    truncate: {
      type: String as PropType<TruncateMode>,
      default: 'none',
      validator: (value: TruncateMode) => TRUNCATE_MODES.includes(value)
    },
    characters: {
      type: Number,
      default: null
    },
    lines: {
      type: Number,
      default: null
    },
    teaser: {
      type: String,
      default: null
    },
    markdown: {
      type: Boolean,
      default: false
    },
    animatedText: {
      type: Boolean,
      default: false
    },
    doubleText: {
      type: Boolean,
      default: false
    },
    textClass: {
      type: String,
      default: ''
    },
    expandedTextClass: {
      type: String,
      default: ''
    },
    alternativeButton: {
      type: Object as PropType<AlternativeButtonConfig>,
      default: null
    }
  },
  setup(props, { root }) {
    const { i18n } = useContext();

    const {
      isTruncated,
      truncatedText,
      renderedText,
      renderedTextLong,
      textClasses,
      toggle: toggleTruncation
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
    } = useTruncatedText(props, root?.$markdown);

    const textElem = ref<HTMLElement | null>(null);

    const { linesCount } = useLinesCounter(
      props.truncate === 'by lines' ? textElem : null
    );

    const readMore = () => {
      toggleTruncation();
    };

    const buttonText = computed(() =>
      isTruncated.value ? i18n.t('Read more') : i18n.t('Read less')
    );

    const showToggleDouble = computed(
      () => props.doubleText && !!renderedTextLong.value.length
    );

    const showToggleMain = computed(() => {
      if (!truncatedText.value) return false;

      if (props.truncate === 'by lines' && props.lines) {
        return linesCount.value > props.lines;
      }

      return true;
    });

    return {
      isTruncated,
      truncatedText,
      renderedText,
      renderedTextLong,
      textClasses,
      textElem,
      linesCount,
      readMore,
      buttonText,
      showToggleDouble,
      showToggleMain
    };
  }
});
